<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <el-button v-if="!couponCheck" type="danger">代理账户</el-button>
        <el-button v-if="couponCheck" type="danger">好友现金券</el-button>
      </div>
      <el-tabs>
        <el-tab-pane>
          <h4 slot="label"> 我的推广</h4>
          <div>

            <h4 v-if="!couponCheck">方法一:扫二维码注册</h4>
            <!-- <h4 v-if="couponCheck">通过以下三种方法邀请好友注册</h4>
            <h4 v-if="couponCheck">好友单次充值满 {{couponAmount * 10}} 元送 {{couponAmount}}</h4>
            <h4 v-if="couponCheck">配资后买入额达到 {{(couponAmount + (couponAmount * 10))*10}} 元即可提现</h4>

            <div v-if="couponCheck"><br></div> -->
            <h4 v-if="couponCheck">方法一：邀请好友扫描二维码注册</h4>


            <div id="qrcode" class="agency_qrcode"></div>
          </div>
          <div>
            <h4 v-if="couponCheck">编号: {{ couponNo }}（只限一人使用）</h4>
            <br>
          </div>

          <div v-if="!couponCheck">
            <h4>方法二:点链接注册&nbsp;&nbsp;<el-button type="danger" size="mini" @click="handleCopy(agencyUrl)">复制链接</el-button></h4>
            <p>{{ agencyUrl }}</p>
          </div>
          <div v-if="couponCheck">
            <h4>方法二:点链接注册&nbsp;&nbsp;<el-button type="danger" size="mini" @click="handleCopy(agencyUrlSub)">复制链接</el-button></h4>
            <p>{{ agencyUrlSub }}</p>
          </div>

          <div v-if="!couponCheck">
            <h4>方法三:注册时填入推荐代码&nbsp;&nbsp;<el-button type="danger" size="mini" @click="handleCopy(code)">复制链接</el-button></h4>
            <p>{{ code }}</p>
          </div>
          <div v-if="couponCheck">
            <h4>方法三:注册时填入推荐代码&nbsp;&nbsp;<el-button type="danger" size="mini" @click="handleCopy(couponNo)">复制链接</el-button></h4>
            <p>{{ couponNo }}</p>
          </div>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon1" v-if="!couponCheck">
          <h4 slot="label"> 我的佣金</h4>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>佣金余额</h3>
                  <p class="red">{{ agent_account }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>管理费佣金</h3>
                  <p class="red">{{ manage_total }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>递延费佣金</h3>
                  <p class="red">{{ deferred_total }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>利润分成</h3>
                  <p class="red">{{ divide_total }}</p>
                </el-col>
                <el-col :span="3" style="text-align: center;line-height: 30px">
                  <h3>提现划转</h3>
                  <p class="red">{{ wit_total }}</p>
                </el-col>
                <el-col :span="9" style="text-align: right">
                  <el-button type="primary" @click="withdrawState = true">提现</el-button>
                  <el-button type="warning" @click="transferState = true">划转</el-button>
                </el-col>
              </el-row>
            </div>
            <el-tabs stretch>
              <el-tab-pane>
                <h4 slot="label">佣金分成</h4>
                <el-table
                  :data="commissionDetails"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="capital_order"
                    label="配资账户">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="金额">
                    <template slot-scope="scope">
                      <p v-bind:style="scope.row.mold==0?'color:red':'color:green'">{{scope.row.mold==0?'':'-'}}{{scope.row.number}}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="balance"
                    label="余额">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label"> 提取总额</h4>
                <el-table
                  :data="withdrawData"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="remark"
                    label="提现划转">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="statustext"
                    label="地位">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="balance"
                    label="余额">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label"> 管理费明细</h4>
                <el-table
                  :data="manageData"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="capital_order"
                    label="配资账户">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="balance"
                    label="余额">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label"> 递延费明细</h4>
                <el-table
                  :data="deferredData"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="capital_order"
                    label="配资账户">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="balance"
                    label="余额">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label"> 利润分成明细</h4>
                <el-table
                  :data="dividedData"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="capital_order"
                    label="配资账户">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="balance"
                    label="余额">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label">会员充值奖励明细</h4>
                <el-table
                  :data="voucherData"
                  style="width: 100%">
                  <!-- <el-table-column
                    align="center"
                    prop="capital_order"
                    label="配资账户">
                  </el-table-column> -->
                  <el-table-column
                    align="center"
                    prop="type"
                    label="类型">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="balance"
                    label="余额">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>

          </el-card>
        </el-tab-pane>
        <el-tab-pane id="isFromCoupon2" v-if="!couponCheck">
          <h4 slot="label"> 我的会员</h4>
          <el-card>
            <el-tabs stretch>
              <el-tab-pane>
                <h4 slot="label"> 所有会员</h4>
                <el-row>
                  <el-col :span="6">
                    <div class="center">
                      <h3>今日会员</h3>
                      <p><span class="red">{{ todayNum }}</span>人</p>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="center">
                      <h3>一级会员</h3>
                      <p><span class="red">{{ levelOne }}</span>人</p>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="center">
                      <h3>二级会员</h3>
                      <p><span class="red">{{ levelTwo }}</span>人</p>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div class="center">
                      <h3>三级会员</h3>
                      <p><span class="red">{{ levelThree }}</span>人</p>
                    </div>
                  </el-col>
                </el-row>
                <div style="margin-top: 10px">
                  <el-table
                    :data="teamData"
                    style="width: 100%">
                    <el-table-column
                      align="center"
                      prop="number"
                      label="会员号">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="user_name"
                      label="会员名">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="phone"
                      label="手机号">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="vip"
                      label="会员等级">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="level"
                      label="代理级别">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="first_voucher"
                      label="首充金额">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="rec_total"
                      label="充值总额">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="time"
                      label="时间"
                      width="150px">
                    </el-table-column>
                  </el-table>
                </div>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label"> 充值会员</h4>
                <el-table
                  :data="rechargeTeamData"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="number"
                    label="会员号">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员名">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="phone"
                    label="手机号">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="vip"
                    label="会员等级">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="level"
                    label="代理级别">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="first_voucher"
                    label="首充金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="rec_total"
                    label="充值总额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间"
                    width="150px">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane>
                <h4 slot="label"> 无充值会员</h4>
                <el-table
                  :data="noRechargeTeamData"
                  style="width: 100%">
                  <el-table-column
                    align="center"
                    prop="number"
                    label="会员号">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="user_name"
                    label="会员名">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="phone"
                    label="手机号">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="vip"
                    label="会员等级">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="level"
                    label="代理级别">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="first_voucher"
                    label="首充金额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="rec_total"
                    label="充值总额">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="时间"
                    width="150px">
                  </el-table-column>
                </el-table>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </el-tab-pane>

        <!-- <el-tab-pane>
          <h4 slot="label">下级持仓人数</h4>
           <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-row>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>月份</h3>
                    <el-date-picker @change="selecteDate" v-model="average_depot_month" type="month" placeholder="选择月份">
                    </el-date-picker>
                </el-col>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>每日持仓人数总和</h3>
                  <p style="padding-top:10px;">{{ total_depot_users }}</p>
                </el-col>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>天数</h3>
                  <p style="padding-top:10px;">{{ total_days }}</p>
                </el-col>
                <el-col :span="6" style="text-align: center;line-height: 30px">
                  <h3>日均持仓人数</h3>
                  <p style="padding-top:10px;">{{ avarage_depot_users }}</p>
                </el-col>
              </el-row>
            </div>
               <div style="margin-top: 10px">
                  <el-table
                    :data="average_depot_people"
                    style="width: 100%">
                    <el-table-column
                      align="center"
                      prop="day"
                      label="日期">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="level1"
                      label="下一级持仓人数">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="level2"
                      label="下二级持仓人数">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="level3"
                      label="下三级持仓人数">
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="total"
                      label="日小计人数">
                    </el-table-column>
                  </el-table>
                </div>

          </el-card>

        </el-tab-pane> -->
      </el-tabs>
    </el-card>
<!--    佣金提现-->
    <el-dialog title="佣金提现" :visible.sync="withdrawState">
      <el-form ref="form" :model="withdrawalData" label-width="100px" size="small">
        <el-form-item label-width="0">
          <h3>请务必用本人({{ withdrawalData.account }})名字的银行卡提款!<el-button type="primary" class="right" @click="bankCardState = true">银行卡管理</el-button></h3>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">银行名称:</h4>
          <p>{{ withdrawalData.name }}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">开户支行:</h4>
          <p>{{ withdrawalData.address }}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">银行卡号:</h4>
          <p>{{ withdrawalData.card }}</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">开户姓名:</h4>
          <p>{{ withdrawalData.account }}</p>
        </el-form-item>
        <br><br>
        <el-form-item label-width="0">
          <h3>请填写提现金额</h3>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">账户金额:</h4>
          <p>{{ agent_account }}元</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">提现金额:</h4>
          <el-input v-model="withdrawalData.money" placeholder="请填写提现金额" style="width: 200px"></el-input>
          <p>提现100元起</p>
        </el-form-item>
        <el-form-item>
          <span slot="label" class="weigth">提现密码:</span>
          <el-input placeholder="请输入提现密码" v-model="withdrawalData.password" show-password style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="withdrawState = false">取 消</el-button>
        <el-button type="primary" @click="withdraw">提现</el-button>
      </div>
    </el-dialog>
<!--    佣金划转-->
    <el-dialog title="佣金划转" :visible.sync="transferState">
      <el-form ref="form" :model="transferData" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">从代理账户:</h4>
          <p>{{ agent_account }}元</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">到本金账户:</h4>
          <p>{{ cash }}元</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">划转金额:</h4>
          <el-input v-model="transferData.number" placeholder="请填写划转金额"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferState = false">取 消</el-button>
        <el-button type="primary" @click="transfer">划 转</el-button>
      </div>
    </el-dialog>
<!--    银行卡管理-->
    <el-dialog title="银行卡管理" :visible.sync="bankCardState">
      <el-table :data="bankCardList">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column property="card" label="卡号" ></el-table-column>
        <el-table-column property="name" label="银行名称" ></el-table-column>
        <el-table-column property="address" label="开户支行"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary"  @click="handleBankCard(scope.row)">确定</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
    export default {
        name: "agency",
      data(){
        return{
          agencyUrl:'',
          agencyUrlSub: '',
          code:'',
          //管理费
          manageData: [],
          commissionDetails: [],
          withdrawData:[],
          voucherData:[],
          //递延费
          deferredData:[],
          //利润分成
          dividedData:[],
          //我的会员
          teamData:[],
          //充值会员,
          rechargeTeamData:[],
          //无充值会员
          noRechargeTeamData:[],
          //一级会员
          levelOne:0,
          //二级会员
          levelTwo:0,
          //三级会员
          levelThree:0,
          //今日会员
          todayNum:0,
          //代理佣金
          agent_account:0,
          cash:0,
          //对话框佣金提现状态
          withdrawState:false,
          //对话框佣金划转状态
          transferState:false,
          //银行卡管理状态
          bankCardState:false,
          //提现
          withdrawalData:{
            name:'',
            card:'',
            address:'',
            account:'',
            money:'',
            password:''
          },
          //划转
          transferData:{
            number:''
          },
          formLabelWidth:'120px',
          //银行卡列表
          bankCardList:[],
          couponAmount: "",
          couponNo: "",
          couponCheck : false,
          subUrl: "",
          isFromCoupon: false,
          wit_total:0,
          manage_total:0,
          deferred_total:0,
          divide_total:0,
          average_depot_people: [],
          average_depot_month: Date.now(),
          total_depot_users: 0,
          avarage_depot_users: 0,
          total_days: 0,
        }
      },
      computed:{
      },
      methods: {
        selecteDate(date){
          this.average_depot_month = date.getTime();
          this.getAverageDepotPeople();
        },
        parse_url(_url){
          var pattern = /(\w+)=(\w+)/ig;//定义正则表达式
          var parames = {};//定义数组
          _url.replace(pattern, function(a, b, c){
            parames[b] = c;
          });
          return parames;//返回这个数组.
        },
        getCode() {
          let that = this;
          that.code = that.parse_url(that.agencyUrl).code;
        },
        qrcode(url) {
          let qrcode = new QRCode('qrcode', {
            width: 200,
            height: 200,
            text: url, // 二维码地址
          })
        },
        getAgencyUrl(){

          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_qrcode",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.agencyUrl = resData.data;
                sessionStorage.setItem("qrcodeUrl",that.agencyUrl);
                var subUrl = sessionStorage.getItem("qrcodeUrl");
                that.$store.commit("qrCodeUrl", subUrl);
                that.subUrlMethod();
                that.qrcode(that.agencyUrl);
                that.getCode();
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },

        getUserUrl(){

          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "coupon_url",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.agencyUrl = resData.data;
                that.agencyUrl = that.agencyUrl.split('=')[0]+"?code=";
                sessionStorage.setItem("qrcodeUrl",that.agencyUrl);
                var subUrl = sessionStorage.getItem("qrcodeUrl");
                that.$store.commit("qrCodeUrl", subUrl);
                that.subUrlMethod();
                that.qrcode(that.agencyUrl);
                that.getCode();
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },

        subUrlMethod(){
          let that = this;
          that.subUrl = this.$store.state.qrCodeUrl;
          // that.agencyUrlSub = that.subUrl.substr(0, 42);
          that.agencyUrlSub = that.subUrl.split('=')[0];
          that.agencyUrlSub = that.agencyUrlSub + "=";
          if(that.$store.state.couponNo) {
            that.couponCheck = true;
            // that.agencyUrlSub = that.subUrl.substr(0, 42);
            that.agencyUrlSub = that.subUrl.split('=')[0];
            that.agencyUrlSub = that.agencyUrlSub + "=";
            that.agencyUrl = that.agencyUrlSub.concat(that.$store.state.couponNo);
            that.agencyUrlSub = that.agencyUrl;
          }
        },

        //获取管理费
        getManageData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_commissioninfo",
                token: sessionStorage.getItem("token"),
                flag:'manage'
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.manageData = resData.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },

        // Get summary agent commission details
        getcommissionDetails(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_flow_log",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.commissionDetails = resData.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },

        getWithdrawData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_withdraw",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.withdrawData = resData.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },
        //获取递延费数据
        getDeferred(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_commissioninfo",
                token: sessionStorage.getItem("token"),
                flag:'deferred'
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.deferredData = resData.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },
        //获取利润分成数据
        getDividedData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_commissioninfo",
                token: sessionStorage.getItem("token"),
                flag:'divided'
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.dividedData = resData.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },
        getVoucherData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_commissioninfo",
                token: sessionStorage.getItem("token"),
                flag:'voucher'
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                that.voucherData = resData.data;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },
        //复制
        handleCopy(copy){
          let text = copy;
          let oInput = document.createElement('input');
          oInput.value = text;
          document.body.appendChild(oInput);
          oInput.select();
          document.execCommand("Copy");
          this.$message({
            message: '复制成功',
            type: 'success'
          });
          oInput.remove()
        },
        //获取我的会员
        getAgentTeam(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_team",
                token: sessionStorage.getItem("token"),
              }
            })
            .then(function (res) {
              let resData = res.data;
              if (res.data.code == 1) {
                let teamData = resData.data;
                that.teamData = teamData;
                let levelOne = 0;
                let levelTwo = 0;
                let levelThree = 0;
                let todayNum = 0;
                let rechargeTeamData = [];
                let noRechargeTeamData = [];
                for (let i = 0,len = teamData.length;i < len; i++){
                  switch (teamData[i].level.substring(0,1)) {
                    case '一':
                      levelOne = levelOne + 1;
                    break;
                    case '二':
                      levelTwo = levelTwo + 1;
                      break;
                    case '三':
                      levelThree = levelThree + 1;
                      break;
                  }
                  if (that.isToday(teamData[i].time)){
                    todayNum = todayNum + 1;
                  }

                  if (teamData[i].rec_total == 0){
                    noRechargeTeamData.push(teamData[i])
                  }else{
                    rechargeTeamData.push(teamData[i])
                  }
                }
                //1级会员
                that.levelOne = levelOne;
                //2级会员
                that.levelTwo = levelTwo;
                //3级会员
                that.levelThree = levelThree;
                //今日会员
                that.todayNum = todayNum;
                //充值会员
                that.rechargeTeamData = rechargeTeamData;
                //无充值会员
                that.noRechargeTeamData = noRechargeTeamData;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        },
        //判断是否是今天
        isToday(str){
          let that = this;
          return that.$moment(that.$moment(str, "YYYY.MM.DD HH:mm:ss").format('YYYY-MM-DD')).isSame(that.$moment().tz("Asia/Shanghai").format("YYYY-MM-DD"));
        },
        //获取用户基本信息
        getUserinfo() {
          let that = this;
          that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "user",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.cash = res.data.data.cash;
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        //获取用户银行卡
        getAccountBank(){
          let that = this;
          that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "accountbank",
                token: sessionStorage.getItem("token")
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.bankCardList = res.data.data;
                that.withdrawalData.account = that.bankCardList[0].account;
                that.withdrawalData.card = that.bankCardList[0].card;
                that.withdrawalData.name = that.bankCardList[0].name;
                that.withdrawalData.address = that.bankCardList[0].address;
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        handleBankCard(row){
          let that = this;
          that.withdrawalData.account = row.account;
          that.withdrawalData.card = row.card;
          that.withdrawalData.name = row.name;
          that.withdrawalData.address = row.address;
          that.bankCardState = false;
        },
        //佣金提现
        withdraw(){
          let that = this;
          let number = that.withdrawalData.money;
          let password = that.withdrawalData.password;
          let name = that.withdrawalData.name;
          let card = that.withdrawalData.card;
          that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_dowithdraw",
                token: sessionStorage.getItem("token"),
                number: number,
                password: password,
                name: name,
                card: card
              }
            })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$message({
                  message: res.data.msg,
                  type: 'success',
                  onClose:function () {
                    that.getUserinfo();
                    that.getWithdrawData();
                    that.withdrawState = false;
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },
        //佣金划转
        transfer(){
          let that = this;
          let number = Number(that.transferData.number).toFixed(2);
          if (number <= 0 || isNaN(number)){
            that.$message.error('请输入正确金额');
          }else{
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "transfer_money",
                token: sessionStorage.getItem("token"),
                number: number,
              }
            })
              .then(function(res) {
                if (res.data.code == 1) {
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                      that.getUserinfo();
                      that.transferState = false;
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
          }

        },

        getAgentAccount(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "agent_account",
              token: sessionStorage.getItem("token")
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.agent_account = res.data.data.account;
                that.wit_total = res.data.data.wit_total;
                that.manage_total = res.data.data.manage_total;
                that.deferred_total = res.data.data.deferred_total;
                that.divide_total = res.data.data.divide_total;
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(res.data.msg);
              }
            });
        },

        getAverageDepotPeople(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_daily_depot",
                token: sessionStorage.getItem("token"),
                date: Math.round(that.average_depot_month/1000)
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.average_depot_people = res.data.data.data;
                that.avarage_depot_users = res.data.data.avarage_depot_users;
                that.total_days = res.data.data.total_days;
                that.total_depot_users = res.data.data.total_depot_users;
              } else if (res.data.code == 0) {
                that.$message.error(res.data.msg);
              }
            });
        }
      },
      created() {
        this.couponAmount = this.$store.state.couponAmount;
        this.couponNo = this.$store.state.couponNo;
      },
      mounted () {
        if(this.$store.state.couponNo) {
          this.getUserUrl();
        } else {
          this.getAgencyUrl();
        }
// if(this.couponCheck == false)
// var cols = document.getElementsByClassName('col1');
//   for(i = 0; i < cols.length; i++) {
//     cols[i].style.backgroundColor = 'blue';
//   }
        //获取推广地址


        // var subUrl = sessionStorage.getItem("qrcodeUrl");


        //获取管理费数据
        this.getManageData();
        //get agent commission detals
        this.getcommissionDetails();
        //get agent withdraw data
        this.getWithdrawData();
        //获取递延费数据
        this.getDeferred();
        //获取利润分成数据
        this.getDividedData();
        //获取我的会员
        this.getAgentTeam();
        //获取用户详细数据
        this.getUserinfo();
        //获取银行卡列表
        this.getAccountBank();

        this.getAgentAccount();
        //get agent voucher data
        this.getVoucherData();

        this.getAverageDepotPeople();


      },
      beforeDestroy() {
        this.$store.state.couponNo = "";
        this.$store.state.couponAmount = "";
      },
    }
</script>

<style scoped>
  .agency_title{
    text-align: center;
  }
  .agency_qrcode{
    width: 200px;
    margin: 25px 0;
  }
  .weigth{
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/agency.vue